import fi from './fi/validation';

const validationTranslations = {};
validationTranslations.fi = fi;

export default validationTranslations;
